export default __webpack_public_path__ + "static/assets/3a471d03f814ee255186cd564f25e413.svg";